import { get_guid } from '../../features/visual-analytics/helpers/misc';
import styles from './Switch.module.scss';

const Switch = ({ isOn, onChanged }: { isOn: boolean; onChanged: (newState: boolean) => void }) => {
  const id = get_guid();
  return (
    <div style={{ display: 'inline-block' }}>
      <input
        className={styles.reactSwitchCheckbox}
        id={id}
        type="checkbox"
        checked={isOn}
        onChange={() => {
          onChanged(!isOn);
        }}
      />
      <label className={styles.reactSwitchLabel} htmlFor={id}>
        <span className={styles.reactSwitchButton} />
      </label>
    </div>
  );
};

export default Switch;
